/* tslint:disable */
/* eslint-disable */
/**
 * Trendtours CMS API
 * ISO API for the IBE. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiProductCard,
    ApiProductCardFromJSON,
    ApiProductCardFromJSONTyped,
    ApiProductCardToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApiWishlistProductsResponse
 */
export interface ApiWishlistProductsResponse {
    /**
     * 
     * @type {Array<ApiProductCard>}
     * @memberof ApiWishlistProductsResponse
     */
    items: Array<ApiProductCard>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiWishlistProductsResponse
     */
    removableIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiWishlistProductsResponse
     */
    unresolvedIds: Array<string>;
}

export function ApiWishlistProductsResponseFromJSON(json: any): ApiWishlistProductsResponse {
    return ApiWishlistProductsResponseFromJSONTyped(json, false);
}

export function ApiWishlistProductsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiWishlistProductsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ApiProductCardFromJSON)),
        'removableIds': json['removableIds'],
        'unresolvedIds': json['unresolvedIds'],
    };
}

export function ApiWishlistProductsResponseToJSON(value?: ApiWishlistProductsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(ApiProductCardToJSON)),
        'removableIds': value.removableIds,
        'unresolvedIds': value.unresolvedIds,
    };
}


// custom code here ##################################################################################################################
function toUTC(date) {
  var date_utc =  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
  return new Date(date_utc);
}
